module.exports = __webpack_public_path__ + "static/media/disc_active2.edc1f338.png";